import React, { Fragment, useState, useEffect } from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import { formatNumber } from '../../../Utils/Money';
import Divider from '@material-ui/core/Divider';

const no_op = () => { };
const SummaryInfoStatusAccount = ({ invoicesData, abonosFromPatient = 0, advancedPayments = null, profileType = 'patient' }) => {
    const [totalInvoices, setTotalInvoices] = useState(0); // total de todas las facturas
    const [totalPayments, setTotalPayments] = useState(0); // total de todos los pagos incluidas las retenciones
    const [totalToPay, setTotalToPay] = useState(0);
    const [inputValue, setInputValue] = useState(0); //Total de abonos de las Facturas
    const [retentions, setRetentions] = useState(0);
    const [totalAdvancedPayments, setTotalAdvancedPayments] = useState(0); //Anticipos realizados por terceros

    useEffect(() => {
        getTotalInvoices(invoicesData);
    }, [invoicesData]);

    useEffect(() => {
        /* if (advancedPayments !== null) {
            let accAdvancedPayments = advancedPayments.reduce((acc, current) => acc + current.valor, 0);
            setTotalAdvancedPayments(accAdvancedPayments);
        } */
        setTotalAdvancedPayments(0);
    }, [advancedPayments])


    const calculateTotal = (invoice) => {
        let total_tercero = 0;
        let total_abonos = 0;
        if (invoice.hasOwnProperty('servicios')) { //Factura en salud
            if (invoice.servicios !== null && invoice.servicios !== undefined) {
                if (invoice.tipo !== null) {
                    if (invoice.tipo === 1) { // cuando es particular el total de la factura es el total del copago
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.total);
                                total_abonos += parseInt(0);
                            })
                        }
                    } else { // cuando es otro regimen 
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.valor_tercero)
                                total_abonos += parseInt(recibo.total);
                            })
                        }
                    }
                }
            } else if (invoice.hasOwnProperty('detalles_comerciales')) { //Factura Comercial
                total_tercero = parseInt(invoice.detalles_comerciales?.total);
                total_abonos = parseInt(invoice.detalles_comerciales?.copago);
            } else {
                total_tercero = 0;
                total_abonos = 0;
            }
        }
        //setTotalInvoice(total_tercero);
        return { ["total_tercero"]: total_tercero, ["total_abonos"]: total_abonos }
    }
    const getTotalInvoices = (invoicesData) => {
        let sumTotalFacturas = 0; // Acumulador cantidades de todas las facturas
        let sumPagos = 0; //Acumulador de pagos
        let sumAbonos = 0; // Acumulador de Abonos de todas las facturas
        let sumRetenciones = 0;
        invoicesData.forEach((invoice) => {
            let totalInvoice = calculateTotal(invoice);
            console.log("totalInvoice", totalInvoice);
            sumTotalFacturas = sumTotalFacturas + totalInvoice.total_tercero;
            let totalPayments = filterPayments(invoice.pagos);
            let totalRetentions = filterRetentions(invoice.pagos)
            let sumPayments = addPayments(totalPayments);
            let sumRetentions = addPayments(totalRetentions);
            console.log("pagos", sumPayments, "retenciones", sumRetenciones);
            sumRetenciones += sumRetentions;
            sumPagos += sumPayments;
            sumAbonos = sumAbonos + totalInvoice.total_abonos;
        })
        setInputValue(sumAbonos);
        setTotalPayments(sumPagos);
        setTotalInvoices(sumTotalFacturas);
        setRetentions(sumRetenciones);
        if (profileType !== 'patient') {
            if (sumTotalFacturas >= (sumPagos + sumRetenciones)) {
                let toPay = sumTotalFacturas - (sumPagos + sumRetenciones);
                setTotalToPay(toPay);
            }
        } else {
            setTotalToPay(sumTotalFacturas);
        }
        return sumTotalFacturas;
    }

    const addPayments = (data) => {
        let acc = 0;
        data.forEach((element) => {
            acc += element.importe;
        })
        return acc;
    }

    //discrimina los pagos de las retenciones
    const filterPayments = (allPaymentsPlusRetentions) => {
        if (allPaymentsPlusRetentions !== null && allPaymentsPlusRetentions !== undefined) {
            let resul = allPaymentsPlusRetentions.filter((element) => element.retencion !== true);
            return resul;
        }

    }
    //discrimina los pagos de las retenciones
    const filterRetentions = (allPaymentsPlusRetentions) => {
        if (allPaymentsPlusRetentions !== null && allPaymentsPlusRetentions !== undefined) {
            let resul = allPaymentsPlusRetentions.filter((element) => element.retencion !== false);
            return resul;
        }

    }
    return (
        <Fragment>
            <Row>
                <div className='top-info-account-status-summary'>
                    <div className='info-side-values'>
                        <div className='item-info-show'>
                            <h4><b>Totales por Cobrar</b></h4>
                            <h3><b>${formatNumber(totalInvoices)}</b></h3>
                        </div>
                        {profileType !== 'patient' ?
                            <Fragment>
                                <div className='item-info-show'>
                                    <h4><b>Pagos Recibidos</b></h4>
                                    <h3><b>${formatNumber(totalPayments)}</b></h3>
                                </div>
                                <div className='item-info-show'>
                                    <h4><b>Retenciones</b></h4>
                                    <h3><b>${formatNumber(retentions)}</b></h3>
                                </div>
                                <div className='item-info-show'>
                                    <h4><b>Anticipos</b></h4>
                                    <h3><b>${formatNumber(totalAdvancedPayments)}</b></h3>
                                </div>
                            </Fragment>
                            : null}
                        {
                            abonosFromPatient !== null ?
                                <div className='item-info-show'>
                                    <h4><b>Abonos</b></h4>
                                    <h3><b>${formatNumber(inputValue + abonosFromPatient)}</b></h3>
                                </div>
                                :
                                < div className='item-info-show'>
                                    <h4><b>Abonos</b></h4>
                                    <h3><b>${formatNumber(inputValue)}</b></h3>
                                </div>
                        }
                    </div>
                    <div>
                        {/* <div >
                            <Divider orientation="vertical" flexItem style={{color: '#55e5bb'}}/>
                        </div> */}
                        {profileType !== 'patient' ?
                            <div className='item-info-show'>
                                <h4><b>Pendiente</b></h4>
                                <h3><b>${advancedPayments !== null ?
                                    totalToPay - totalAdvancedPayments < 0 ? "+" + formatNumber(Math.abs(totalToPay - totalAdvancedPayments))
                                        : formatNumber(totalToPay - totalAdvancedPayments)
                                    : totalToPay}</b></h3>
                            </div>
                            :
                            <div className='item-info-show'>
                                <h4><b>Pendiente</b></h4>
                                <h3><b>${totalToPay - (inputValue + abonosFromPatient) < 0 ? "+" + formatNumber(Math.abs(totalToPay - (inputValue + abonosFromPatient))) : totalToPay - (inputValue + abonosFromPatient)}</b></h3>
                            </div>
                        }
                    </div>
                </div>
            </Row>
        </Fragment >
    )
}

export default SummaryInfoStatusAccount